import lodash from "lodash";
import Vuetify from "vuetify";
import { FormInformation } from "@/modules/GeneralRules/models/FormInformationMapped.model";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  FORM_ACTION_CONSTANTS,
  INFORMATION_INIT
} from "../../constants/FormActionModal.constants";
import { FormStatus } from "@/modules/FormTemplate/models/FormStatus";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import InformationElement from "../InformationElement.vue/InformationElement.vue";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";

Vue.use(Vuetify);
@Component({
  name: "InformationComponent",
  components: { InformationElement, DynamicSelect }
})
export default class InformationComponent extends Vue {
  @Prop({ default: false }) isEditing!: boolean;
  @Prop({ default: 0 }) editingEvent!: number;
  @Prop() formToGenerate!: string | FormStatus;
  @Prop() formInformationArray!: FormInformation[];
  @Prop() formTemplates!: FormStatus[];

  INFORMATION_HELP = FORM_ACTION_CONSTANTS.LABELS.INFORMATION_HELP;
  SELECT_TEMPLATE = FORM_ACTION_CONSTANTS.LABELS.SELECT_GENERATE_TEMPLATE;
  GET_INFORMATION = FORM_ACTION_CONSTANTS.LABELS.GET_INFORMATION;

  primaryIconClass = STYLE_CLASSES.PRIMARY_ICON;
  primaryRoundBtnClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;

  requiredFieldObject = [FORM_VALIDATORS.REQUIRED_OBJECT];

  formTemplateModel = [{ id: "", name: "" }];
  formSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: this.SELECT_TEMPLATE,
    hideDetails: true
  };

  get selectedFormKey() {
    return this.formTemplateModel[0].id;
  }

  set selectedFormKey(value: string) {
    const option = this.formSelectConfig.listAll.find(
      item => item.id === value
    );
    this.formTemplateModel = [
      {
        id: option?.id ?? "",
        name: option?.name ?? ""
      }
    ];
  }

  created() {
    this.updateDataDynamicSelect();
    this.localGenerationTemplateUpdate();
  }

  @Watch("formToGenerate")
  localGenerationTemplateUpdate() {
    this.selectedFormKey = (this.formToGenerate as FormStatus)._key;
  }

  @Watch("formTemplateModel")
  generationTemplateChanged() {
    const templateSelected = this.formTemplates.find(
      e => e._key == this.selectedFormKey
    );
    this.$emit(
      FORM_ACTION_CONSTANTS.EVENTS.UPDATE_GENERATION_TEMPLATE,
      templateSelected
    );
  }

  addInformation() {
    const info = lodash.clone(INFORMATION_INIT);
    info.key =
      FORM_ACTION_CONSTANTS.INFORMATION_KEY + this.formInformationArray.length;
    this.$emit(FORM_ACTION_CONSTANTS.EVENTS.INFORMATION.ADD, info);
  }

  editElement(formInformation: FormInformation, index: number) {
    this.$emit(
      FORM_ACTION_CONSTANTS.EVENTS.INFORMATION.EDIT_ELEMENT,
      formInformation,
      index
    );
  }

  deleteElement(index: number) {
    this.$emit(
      FORM_ACTION_CONSTANTS.EVENTS.INFORMATION.DELETE_FROM_ARRAY,
      index
    );
  }

  getFormTemplates(name?: string) {
    this.$emit(FORM_ACTION_CONSTANTS.EVENTS.LOAD_FORM_TEMPLATES, name);
  }

  @Watch("formTemplates")
  updateDataDynamicSelect() {
    this.formSelectConfig.listAll = this.formTemplates.map(item => {
      return { id: item._key, name: item.name };
    });
  }
}
